// pages/ActiveMasters.jsx
import React from 'react';
import MasterListBase from './MasterListBase';

const ActiveMasters = () => (
    <MasterListBase statusFilter="active" title="Active Masters" subtitle="Masters currently active" />
);

export default ActiveMasters;